import { AMENITY_CATEGORIES } from './communitySiteUtils';

const NON_BOOKABLE_IDS = new Set([
  'garden',
  'fountain',
  'walking_path',
  'cycling_path',
  'stp',
  'transformer',
  'dg',
  'pump',
  'garbage',
  'entry_gate',
  'exit_gate',
]);

export const NO_SECONDARY_LOCATION = '— None —';

export const getClubHouseFloorLocations = clubHouse => {
  const name = clubHouse?.name || 'Club House';
  const floors = clubHouse?.floors ?? 0;
  return Array.from({ length: floors }, (_, i) => `${name} — Floor ${i + 1}`);
};

export const isClubHouseAmenity = template =>
  template?.category === AMENITY_CATEGORIES.CLUB_HOUSE;

export const isGardenAmenity = template => template?.id === 'garden';

export const isBookableAmenity = template =>
  template?.isCustom || !NON_BOOKABLE_IDS.has(template?.id);

export const defaultAmenityDetails = () => ({
  bookingRequired: false,
  maintenanceFrequency: 'Weekly',
  capacity: '20',
  openTime: '06:00',
  closeTime: '22:00',
  gardenType: 'Central',
  irrigation: false,
  seating: true,
  lighting: true,
  notes: '',
});

export const buildLocationItems = ({ locationOptions, clubHouse, isClubHouse }) => {
  if (!isClubHouse || !clubHouse) return locationOptions;

  const chName = clubHouse.name || 'Club House';
  const floorLocations = getClubHouseFloorLocations(clubHouse);
  return [
    'Entire Site',
    chName,
    ...floorLocations,
    ...locationOptions.filter(o => o !== 'Entire Site' && !o.startsWith(chName)),
  ];
};

export const buildClubHouseFloorOptions = clubHouse => {
  const chName = clubHouse?.name || 'Club House';
  return [chName, ...getClubHouseFloorLocations(clubHouse)];
};

export const resolveClubHouseFloorValue = (location, clubHouse) => {
  const options = buildClubHouseFloorOptions(clubHouse);
  if (options.includes(location)) return location;
  const match = options.find(opt => location.startsWith(opt));
  return match || options[0] || location;
};

export const initialLocationForAmenity = ({
  amenity,
  clubHouse,
  locationOptions,
}) => {
  let location = amenity.locationMapping || 'Entire Site';
  if (
    isClubHouseAmenity(amenity.template) &&
    clubHouse &&
    location === 'Entire Site'
  ) {
    const floors = getClubHouseFloorLocations(clubHouse);
    location = floors.length > 0 ? floors[0] : clubHouse.name || 'Club House';
  }
  const items = buildLocationItems({
    locationOptions,
    clubHouse,
    isClubHouse: isClubHouseAmenity(amenity.template),
  });
  if (!items.includes(location)) {
    location = items[0] || location;
  }
  return location;
};
